export const language: any = {
    LabelLogin: "ログイン",
    LabelForgotPw: "パスワードをお忘れですか",
    LabelSignUp: "会員登録",
    LabelRememberMe: "ログイン状態を保持する",
    Or: "または",
    Email: "メールアドレス",
    Password: "パスワード",
    LangKo: "韓国語",
    LangEn: "英語",
    LangVi: "ベトナム語",
    LabelCondition: "利用規約同意",
    FullAgreement: "全て同意する",
    Next: "次へ",
    PrivacyPolicy: `個人情報保護方針 <span class="text-[#ff6741]">(必須)</span>`,
    TermOfUse: `利用規約 <label class="text-[#ff6741]">(必須)</label>`,
    VerifyPassword: "パスワード確認",
    PlaceHolderPassword: "英字+数字+特殊文字を含む8文字以上を入力",
    DuplicateCheck: "重複確認",
    LabelIdEmail: "ID（メールアドレス）",
    GN_02_MSG_01: "お使いのアプリバージョンが古いです。最新バージョンにアップグレードしてください。",
    AU_02_MSG_02: "このメールアドレスは既にシステムに登録されています。別のメールアドレスをご使用ください。",
    AU_02_MSG_03: "使用可能なメールアドレスです。",
    AU_02_MSG_01: "正しいメールアドレス形式を入力してください。",
    AU_01_MSG_01: "IDまたはパスワードが一致しません。再試行してください。",
    AU_02_MSG_04: "使用可能なメールアドレスを確認してください。",
    AU_02_MSG_05: "英字、数字、特殊文字を含む8文字以上で入力してください。",
    AU_02_MSG_06: "パスワードが一致しません。",
    AU_03_MSG_01: "正確なメールアドレスを入力してください。",
    AU_03_MSG_02: "このメールアドレスはシステムに登録されていません。",
    AU_03_MSG_04: "※認証コードが登録されたメールに送信されました。",
    LabelRegisterComplete: "会員登録が完了しました！",
    LabelLoginToUseService: "ログインしてサービスを利用してください。",
    LabelDontRememberPassword: "パスワードをお忘れですか？",
    LabelYouCanFindEmail: "メール認証を通じて探すことができます。",
    LabelPasswordTemporarySendToEmail: "※登録されたメールに仮パスワードを送信します。",
    SendVerifyNumber: "認証番号を送信",
    LabelCheckYourEmailForTemporaryPassword: "メールで仮パスワードをご確認ください。",
    PlaceHolderTemporaryPassword: "仮パスワードを入力",
    LabelTemporaryPassword: "仮パスワード",
    LabelDidntReceiveYourPassword: "パスワードが届いていませんか？",
    LabelYouCanResendItAfter: "後に再送信できます。",
    LabelYouCanResendAgain: "再送信できます。",
    Confirm: "確認",
    Resend: "再送信",
    LabelResetPassword: "パスワードリセット",
    NewPassword: "新しいパスワード",
    ConfirmNewPassword: "新しいパスワード確認",
    PlaceHolderConfirmPassword: "パスワード確認",
    CurrentPassword: "現在のパスワード", //menu
    LanguageSetting: "言語設定", //menu
    LeaveMembership: "退会", //menu
    LabelConfirmPasswordToLeaveMemberShip: "退会するためにパスワードを確認してください。", //menu
    LabelConfirmPasswordMeansYouAgreeAllContent: "パスワードを確認することで、全てのガイド内容を確認し、同意したことを意味します。", //menu
    LabelCancelMembership: "退会する", //menu
    LabelBeforeLeaveYouCheckedContent: "退会前に以下の案内事項をご確認の上、同意をチェックしてください。", //menu
    LabelAfterLeaveAllInfoWillRemove: "退会後、会員情報および利用記録は全て削除され、復元できません。", //menu
    LabelIHaveReadAndAgreeContent: "案内事項を全て確認し、同意しました。", //menu
    ToUnsubscribe: "退会する", //menu
    LabelWouldYouWantLogout: "ログアウトしますか？", //menu
    ChangePassword: "パスワード変更", //menu
    Menu: "メニュー", //menu
    MenuLanguageSettings: "言語設定", //menu
    MenuPrivacyPolicy: "個人情報保護方針", //menu
    MenuLogout: "ログアウト", //menu
    MenuLeaveMembership: "退会", //menu
    LabelAreYouSureLeaveMembership: "本当に退会しますか？", //menu
    LabelIfLeaveMembershipAllInfoWillRemove: "退会すると、アカウント情報が削除され復元できなくなります。", //menu
    LabelPrivacyPolicy: "個人情報保護方針",
    LabelTermOfUse: "利用規約",
    MI_02_MSG_01: "現在のパスワードが正しくありません。",
    LabelModalLogin: `この機能を利用するには、<br/>ログインまたは会員登録をしてください`,
    LabelIdLogin: "IDでログイン",
    LabelSnsApple: "Appleでログイン",
    LabelSnsFacebook: "Facebookでログイン",
    LabelSnsGoogle: "Googleでログイン",
    LabelItemLogin: "Hey! Cookerと一緒にさまざまな機能を探るには、ログインまたは会員登録してください。",
    LabelSnsEmail: "メールでログイン",
    LoadingLogin: "少々お待ちください。",
    MenuNotificationSettings: "通知設定", //menu
};
